<template>
	<div class="modal" id="detach-user-modal" tabindex="-1" role="dialog" aria-labelledby="detachUserModal" aria-hidden="true">
		<div class="modal-dialog modal-sm modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Detach User</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div v-if="user" class="modal-body">
					<p>Are you sure you want to detach {{ user.fullname }} from this company?</p>
				</div>
				<div class="modal-footer">
					<div class="wd-100p d-flex flex-column flex-sm-row">
						<button type="submit" class="btn btn-danger shadow-sm mg-b-5 mg-sm-b-0 col-6" @click="$emit('detach-user')">Yes, Delete</button>
						<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5 col-6" data-dismiss="modal">No, Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
                
<script>
export default ({
    props: {
        user: Object,
        required: false,
    }
})
</script>